import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { PersistenceService } from './persistence.service';

export interface SelectedTenantContext {
  _id: string;
  name: string;
  slug: string;
}

const STORAGE_KEY = 'selectedTenant';

@Injectable({
  providedIn: 'root',
})
export class TenantContextService {
  private readonly selectedTenantSubject = new BehaviorSubject<SelectedTenantContext | null>(
    this.persistenceService.get<SelectedTenantContext | null>(STORAGE_KEY),
  );

  readonly selectedTenant$ = this.selectedTenantSubject.asObservable();

  constructor(private readonly persistenceService: PersistenceService) {}

  getSelectedTenant(): SelectedTenantContext | null {
    return this.selectedTenantSubject.value;
  }

  getSelectedTenantId(): string | null {
    const tenant = this.getSelectedTenant() as
      | (SelectedTenantContext & { id?: string; tenantId?: string })
      | null;

    const tenantId = tenant?._id || tenant?.tenantId || tenant?.id || null;
    if (typeof tenantId !== 'string') {
      return null;
    }

    const normalizedTenantId = tenantId.trim();
    return normalizedTenantId || null;
  }

  setSelectedTenant(tenant: SelectedTenantContext | null): void {
    if (tenant === null) {
      this.persistenceService.remove(STORAGE_KEY);
    } else {
      this.persistenceService.set(STORAGE_KEY, tenant);
    }
    this.selectedTenantSubject.next(tenant);
  }

  clearSelectedTenant(): void {
    this.setSelectedTenant(null);
  }
}
